export default "__VITE_ASSET__BhbXo6R9__"